//@ts-nocheck
//NOTE - firstname, hotel, startDate, endDate, countLead,adults,kids,ages,priceName,room,priceCount
export default function (values, template) {
  const { firstName, room, checkIn, checkOut, night, adults, price, ages, typePrice } = values;
  let agesKids = ''
  if (ages) {
    let agesArr = ages.split(",");
    for (let i = 0; i < agesArr.length; i++) {
      agesKids += `<li><strong>Ребенок: ${i + 1}</strong> возраст ${agesArr[i]} </li>`;
    }
  }
  const html =
    `
          <table align="center" border="0" cellpadding="0" cellspacing="0" width="80%">
        <tr><td>
          <h1 style"font-weight: bold; font-size: 20px; text-align:center;">
          ${values?.siteTitle ? `<a href="https://${values?.siteDisplay}" target="_blank">${values?.siteTitle}</a>` : ''}

          </h1>
        <p>Благодарим за Ваш выбор!</p>
        ${values.firstName ? `<p>Уважаемый(ая) ${values.firstName}</p>` : ''}
        ${template && template.header && template.header.length > 0 ? template.header : (`
             ${values && values.siteTitle ? `<p>Мы получили Ваш Запрос на бронирование отдыха в 
                <a href="https://${values?.siteDisplay}" target="_blank"  style"font-weight: bold;">${values.siteTitle}</a>
                </p>` : ''}
        <p>Ожидайте подтверждение бронирования от отдела продаж в ближайшее время.</p> 
            `)}
        <h1 style='margin-top: 30px;'>ДЕТАЛИ ЗАКАЗА:</h1>
        <p style"font-weight: bold;">Бронирование #${values?.invoice}</p>
        <ul>
        ${values.room ? `<li><strong>Номер категории: </strong> <span class="text">
            <a target="_blank" href="https://${values?.siteDisplay}/rooms/${values?.roomSlug}">${values.room}</a>
            </span ></li>` : ''}
        ${values.checkIn ? `<li><strong>Заезд: </strong> <span class="text">${values.checkIn}</span ></li>` : ''}
        ${values.checkOut ? `<li><strong>Выезд: </strong> <span class="text">${values.checkOut}</span ></li>` : ''}
        ${values.night ? `<li><strong>Ночей: </strong> <span class="text">${values.night}</span ></li>` : ''}
        ${values.adults ? `<li><strong>Взрослых: </strong> <span class="text">${values.adults}</span ></li>` : ''}
        ${agesKids ? agesKids : ''}
        ${values.typePrice ? `<li><strong>Тариф: </strong> <span class="text">${values.typePrice}</span ></li>` : ''}
        ${values.price ? `<li><strong>Стоимость: </strong> <span class="text">${values.price}</span ></li>` : ''}
       </ul>
       <br />
        ${template && template.content && template.content.length > 0 ? template.content : ''}
        ${template && template.contacts && template.contacts.length > 0 ? template.contacts : (`
           <p>Если у Вас остались вопросы, или Вы хотите изменить данные бронирования, звоните:</p> 
<p><a href="tel:78005113515">+7(800) 511-35-15 (бесплатно)</a></p>
<p>или пишите нам:</p>
<p><a href="mailto:${values.worckMail}">${values.worckMail}</a></p>
<p><a href="tel:79780101260">+7 978 010-12-60 (Telegram, WhatsApp).</a></p>
        `)}
        </td></tr>
       <tr>
    <td style="padding: 10px;">
    <p style"font-weight: bold;">В дополнение к Вашему отдыху предлагаем:</p>
    <br />
      <a href="https://bagtravels.ru/page/transfer-po-krymu" target="_blank" style="display: inline-block; padding: 12px 24px; background-color: rgb(13, 202, 240); color: #FFFFFF; text-decoration: none; font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-weight: bold; border-radius: 5px; text-align: center;">Заказать индивидуальный трансфер</a>
     </td>
  </tr>
       <tr>
    <td style="padding: 10px">
      <a href="https://bagtravels.ru/page/ekskursii-po-krymu" target="_blank" style="display: inline-block; padding: 12px 24px; background-color: rgb(13, 202, 240); color: #FFFFFF; text-decoration: none; font-family: Arial, Helvetica, sans-serif; font-size: 16px; font-weight: bold; border-radius: 5px; text-align: center;">Заказать экскурсию по Крыму</a>
    </td>
  </tr>
        <tr>
        <td>
        <p style"font-weight: bold;">С наилучшими пожеланиями, отдел бронирования!</p>
        </td>
        </tr>
        </table>
        `;
  return html;
}